import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Tooltip,
} from "@material-tailwind/react";
import { FaLinkedin } from "react-icons/fa";

// ==================== CONSTANTES ====================
const DEFAULTS = {
  role: "Colaborador",
  position: "Miembro del equipo",
  description: "Descripción no disponible",
};

const STYLES = {
  card: "w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg shadow-lg hover:shadow-2xl transition-shadow duration-300",
  header: "h-80 overflow-hidden",
  image: "w-full h-full object-cover transition-transform duration-500 hover:scale-110",
  body: "text-left",
  name: "text-primary mb-2 font-bold",
  role: "font-semibold text-gray-700",
  position: "text-sm font-medium text-blue-600 mt-1",
  description: "text-sm mt-3 text-gray-600",
  footer: "flex justify-start gap-4 pt-2",
  socialIcon: "transition-transform duration-300 hover:scale-125",
};

const SOCIAL_CONFIG = {
  linkedin: {
    color: "#0e76a8",
    size: 20,
    label: "LinkedIn",
  },
};

// ==================== COMPONENTES ====================
const MemberImage = ({ src, name }) => (
  <CardHeader floated={false} className={STYLES.header}>
    <img 
      src={src} 
      alt={`Foto de perfil de ${name}`}
      className={STYLES.image}
      loading="lazy"
    />
  </CardHeader>
);

const MemberInfo = ({ name, role, position, biography }) => (
  <CardBody className={STYLES.body}>
    <Typography 
      variant="h4" 
      className={STYLES.name}
      as="h3"
    >
      {name}
    </Typography>
    
    <Typography 
      color="gray" 
      className={STYLES.role}
      as="p"
    >
      {role || DEFAULTS.role}
    </Typography>

    {position && (
      <Typography 
        className={STYLES.position}
        as="p"
      >
        {position}
      </Typography>
    )}
    
    <Typography 
      color="blue-gray" 
      className={STYLES.description}
      as="p"
    >
      {biography || DEFAULTS.description}
    </Typography>
  </CardBody>
);

const SocialLink = ({ url, icon: Icon, config, ariaLabel }) => {
  if (!url) return null;

  return (
    <Tooltip content={config.label}>
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        className={STYLES.socialIcon}
      >
        <Icon 
          size={config.size} 
          color={config.color}
          aria-hidden="true"
        />
      </a>
    </Tooltip>
  );
};

const SocialLinks = ({ linkedIn, memberName }) => {
  const hasSocialLinks = linkedIn;

  if (!hasSocialLinks) return null;

  return (
    <CardFooter className={STYLES.footer}>
      <SocialLink
        url={linkedIn}
        icon={FaLinkedin}
        config={SOCIAL_CONFIG.linkedin}
        ariaLabel={`Ver perfil de LinkedIn de ${memberName}`}
      />
    </CardFooter>
  );
};

// ==================== COMPONENTE PRINCIPAL ====================
const OurTeamCard = ({ member, translation }) => {
  // Validación básica
  if (!member || !member.name) {
    return null;
  }

  return (
    <Card className={STYLES.card}>
      <MemberImage 
        src={member.img} 
        name={member.name} 
      />
      
      <MemberInfo
        name={member.name}
        role={member.role}
        position={member.description}
        biography={translation}
      />
      
      <SocialLinks 
        linkedIn={member.linkedIn}
        memberName={member.name}
      />
    </Card>
  );
};

export default OurTeamCard;